<div class="cw">
    <div fxLayout="row" fxLayoutAlign=" center" class="mgt40">
        <h6 *ngIf="id" class="ft500"> Editar Curso</h6>
        <h6 *ngIf="!id" class="ft500"> Agregar Curso</h6>
        <div fxLayout="row" class="mgl20" fxFlex="20%">
            <div fxLayout="column" fxLayoutAlign="center center" fxFlex="100%" class="tipoBusquedaButton radius3"
                (click)="tipoBusqueda='info'" [ngClass]=" {'backGray2':tipoBusqueda === 'info'}">
                <span>Info</span>
            </div>
            <div *ngIf="id" fxLayout="column" fxLayoutAlign="center center" fxFlex="100%"
                class="tipoBusquedaButton radius3" (click)="tipoBusqueda='sesion'"
                [ngClass]=" {'backGray2':tipoBusqueda === 'sesion'}">
                <span>Sesion</span>
            </div>
            <div *ngIf="id" fxLayout="column" fxLayoutAlign="center center" fxFlex="100%"
                class="tipoBusquedaButton radius3" (click)="tipoBusqueda='examen'"
                [ngClass]=" {'backGray2':tipoBusqueda === 'examen'}">
                <span>Examen</span>
            </div>
        </div>
    </div>
    <div *ngIf="tipoBusqueda == 'info'">
        <editar-curso-info></editar-curso-info>
    </div>
    <div *ngIf="tipoBusqueda == 'sesion'">
        <editar-curso-sesiones></editar-curso-sesiones>
    </div>
    <div *ngIf="tipoBusqueda == 'examen'">
        <editar-curso-examen></editar-curso-examen>
    </div>
</div>